// This file is currently the one being used

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getFirestore} from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCzRXq-xfdJL0ImGYm-zMkunYgIBIRXWmc",
  authDomain: "schoolwio-92950.firebaseapp.com",
  projectId: "schoolwio-92950",
  storageBucket: "schoolwio-92950.appspot.com",
  messagingSenderId: "101369217769",
  appId: "1:101369217769:web:f3db016599c964fdd42678",
  measurementId: "G-26EJK77QBG"
};

// Initialize Firebase
initializeApp(firebaseConfig);
export const db = getFirestore();
// const analytics = getAnalytics(app);